import React, {useEffect, useState} from 'react';
import { Route, Switch, Redirect } from 'react-router';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { getDeathDeclaration, getDocuments } from './../../../actions/facilita-api';
import { fetchPartnerCustomization } from './../../../actions/user-api';
import {useParams} from "react-router-dom";
import * as R from 'ramda';

// Declarer
// ==========================================
// Declarer: Common
import { Navbar } from './_common/navbar';
import { Help } from '../_common/help';
import { Path } from '../_common/path';

// Declarer: Views
import { Step1 } from './step1';
import { Step2 } from './step2';
import { Step3 } from './step3';
import { Step4 } from './step4';

export const Declarer = () => {
	const history = useHistory();
	const dispatch = useDispatch();
	const router = useSelector(state => state.router);
	const facilitaState = useSelector(state => state.facilita);
	const deathDeclarationState = useSelector(state => state.deathDeclaration);

	let { userId } = useParams();
	let deceasedUser = facilitaState.representing.find(r => r.id === userId);

	const [partnerCustomization, setPartnerCustomization] = useState({
		isLoaded: false,
		logoBase64Encoded: undefined,
		color: undefined
	  });

	useEffect(() => {
		if (!R.isNil(facilitaState.user) && !R.isNil(deceasedUser)) {
			if(!R.isNil(deceasedUser.partnerId) && deceasedUser.partnerId !== '00000000-0000-0000-0000-000000000000'){
				fetchPartnerCustomization(deceasedUser.partnerId)
				.then((customization) => {
					if(!R.isNil(customization)){
						setPartnerCustomization({...customization, isLoaded: true});
					}
				})
				.catch(() => setPartnerCustomization({...partnerCustomization, isLoaded: true}))
			}else{
				setPartnerCustomization({...partnerCustomization, isLoaded: true})
			}

		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [facilitaState.user, deceasedUser]);

    useEffect(() => {
        if (!R.isNil(deceasedUser)) {
            dispatch(getDeathDeclaration(deceasedUser.id, deceasedUser));
			dispatch(getDocuments(deceasedUser.id));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [facilitaState.representing]);


	if(R.isNil(deceasedUser) || R.isNil(deathDeclarationState) || R.isNil(deathDeclarationState.declaration) || !partnerCustomization.isLoaded){
		return "";
	}

	// if(deathDeclarationState.declaration.onBoardingStep === 6){
	// 	return <Redirect exact to={`/facilita/${userId}`} />
	// }



	return (
		<div className={"layout layout-row" + (!R.isNil(partnerCustomization) && !R.isNil(partnerCustomization.color) && partnerCustomization.color !== "" ? "" : " bg-gradient-primary")} style={{backgroundColor: "#" + partnerCustomization.color }}>
			<h1 className="sr-only visually-hidden">Assist@</h1>
			<Navbar location={router.location} deceasedUser={deceasedUser} deathDeclaration={deathDeclarationState.declaration} partnerColor={partnerCustomization.color} logoContent={partnerCustomization.logoBase64Encoded} user={facilitaState.user} />
			<main role="main" className="view flex-grow-1 bg-gradient-light">
				<h1 className="sr-only visually-hidden">Assist@: Main</h1>
				<div className='container-fluid flex-md-row align-items-center gap-xs pt-3'>
					<Help row={true} />
					<Path deceasedUser={deceasedUser} declaration={deathDeclarationState.declaration} serviceDatas={deathDeclarationState.serviceDatas} userLetters={deathDeclarationState.userLetters} />							
				</div>
				<Switch>
					<Route path="/facilita/:userId/declarer/step1">
						<Step1 user={deathDeclarationState.declaration} deceasedUser={deceasedUser} files={deathDeclarationState.files} isLoading={deathDeclarationState.isLoading} />
					</Route>
					<Route path="/facilita/:userId/declarer/step2">
						<Step2 deathDeclaration={deathDeclarationState.declaration} userId={deceasedUser.id} isLoading={deathDeclarationState.isLoading} serviceDatas={deathDeclarationState.serviceDatas} />
					</Route>
					<Route path="/facilita/:userId/declarer/step3">
						<Step3 deathDeclaration={deathDeclarationState.declaration} userId={deceasedUser.id} user={facilitaState.user} isLoading={deathDeclarationState.isLoading} />
					</Route>
					<Route path="/facilita/:userId/declarer/step4">
						<Step4 deathDeclaration={deathDeclarationState.declaration} userId={deceasedUser.id} files={deathDeclarationState.files} isLoading={deathDeclarationState.isLoading} />
					</Route>
					<Route render={() => {
						return <Redirect exact to="/facilita/:userId/declarer/step1" />
					}} />
				</Switch>
			</main>
		</div>
	)
}